// import React from 'react';
// import { motion } from "framer-motion";
// import { 
//   Facebook, 
//   Twitter, 
//   Linkedin, 
//   Instagram, 
//   Mail, 
//   Phone, 
//   MapPin, 
//   Globe
// } from 'lucide-react';
// import { Link } from 'react-router-dom';

// const Footer = () => {
//   const productLinks = [
//     { name: 'Features', path: '/features' },
//     { name: 'Pricing', path: '/pricing' }, 
//     { name: 'Bulk SMS', path: '/products/bulk-sms' },
//     { name: 'OTP SMS', path: '/products/otp' },
//     { name: 'IVR Service', path: '/products/ivr' },
//     { name: 'LMS', path: '/products/lms' },
//     { name: 'Missed Call', path: '/products/missed-call' },
//     { name: 'Whatsapp API', path: '/products/whatsapp' },
//   ];

//   const legalLinks = [
//     { name: 'Privacy Policy', path: '/privacy-policy' },
//     { name: 'Terms & Conditions', path: '/terms-and-conditions' },
//     { name: 'Cookie Policy', path: '#' },
//   ];

//   return (
//     <footer className="bg-slate-950 text-slate-300 font-sans border-t border-slate-800">
//       <div className="max-w-7xl mx-auto px-6 py-16">
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          
//           <div className="lg:col-span-4 space-y-6">
//             <div className="flex items-center z-10">
//               <a href="/" className="group cursor-pointer no-underline bg-[#F0EFEB] p-3 rounded-xl border border-white/5 hover:bg-slate-50/10 transition-colors">
//                 <h1 className="text-3xl font-extrabold tracking-widest uppercase flex items-baseline">
//                   <span className="font-[Roboto] text-[#0C4550] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)] bg-clip-text text-transparent bg-gradient-to-br from-white to-slate-400 lg:text-[#0C4550] lg:bg-none lg:text-current">
//                     <span className="text-[#0C4550] lg:text-[#0C4550] drop-shadow-md">EURO</span>
//                   </span>
//                   <span className="font-[Roboto] text-[#F46653] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)]">
//                     FOX
//                   </span>
//                   <span className="w-2.5 h-2.5 rounded-full bg-[#F46653] ml-1 animate-pulse shadow-sm"></span>
//                 </h1>
//               </a>
//             </div>

//             <p className="text-slate-400 leading-relaxed text-sm pr-4">
//               Empowering businesses with reliable, high-speed bulk SMS solutions. 
//               Connect with your audience instantly through our secure, enterprise-grade 
//               global gateway tailored for maximum delivery rates.
//             </p>
//           </div>

//           <div className="lg:col-span-2">
//             <p className="text-white font-semibold text-lg mb-6 relative inline-block">
//               Product
//               <span className="absolute -bottom-2 left-0 w-8 h-1 bg-[#F46653] rounded-full"></span>
//             </p>
//             <ul className="space-y-3 text-sm">
//               {productLinks.map((item) => (
//                 <li key={item.name}>
//                   <Link 
//                     to={item.path} 
//                     className="hover:text-blue-400 transition-all duration-300 ease-in-out block hover:translate-x-2"
//                   >
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <div className="lg:col-span-2">
//             <p className="text-white font-semibold text-lg mb-6 relative inline-block">
//               Legal
//               <span className="absolute -bottom-2 left-0 w-8 h-1 bg-[#F46653] rounded-full"></span>
//             </p>
//             <ul className="space-y-3 text-sm">
//               {legalLinks.map((item) => (
//                 <li key={item.name}>
//                   <Link 
//                     to={item.path} 
//                     className="hover:text-blue-400 transition-all duration-300 ease-in-out block hover:translate-x-2"
//                   >
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <div className="lg:col-span-4">
//             <p className="text-white font-semibold text-lg mb-6 relative inline-block">
//               Our Company
//               <span className="absolute -bottom-2 left-0 w-8 h-1 bg-[#F46653] rounded-full"></span>
//             </p>
//             <ul className="space-y-4 text-sm">
//               <li>
//                 <Link
//                   to="/about" 
//                   className="hover:text-blue-400 transition-all duration-300 ease-in-out block font-medium hover:translate-x-2"
//                 >
//                   About Us
//                 </Link>
//               </li>

//               <li>
//                 <Link
//                   to="/contact" 
//                   className="hover:text-blue-400 transition-all duration-300 ease-in-out block font-medium hover:translate-x-2"
//                 >
//                   Contact Us
//                 </Link>
//               </li>
              
//               {/* SHINY ANIMATED LINE 1 */}
//               <li className="relative h-px w-full overflow-hidden bg-slate-800 my-2">
//                 <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#F46653]/40 to-transparent animate-[shimmer_2s_infinite] -translate-x-full"></div>
//               </li>

//               <li className="flex items-start space-x-3 group cursor-default">
//                 <MapPin className="w-5 h-5 text-white group-hover:text-[#F46653] transition-colors duration-200 mt-0.5 shrink-0" />
//                 <span className="group-hover:text-white transition-colors duration-200">
//                   Abhay Khand-2, Indirapuram,<br />
//                   Ghaziabad, Uttar Pradesh-<br />
//                   201014
//                 </span>
//               </li>

//               <li className="flex items-center space-x-3 group cursor-pointer">
//                 <Phone className="w-5 h-5 text-white group-hover:text-[#F46653] transition-colors duration-200 shrink-0" />
//                 <span className="group-hover:text-white transition-colors duration-200">
//                     +91-9305559674
//                 </span>
//               </li>

//               <li className="flex items-center space-x-3 group">
//                 <Mail className="w-5 h-5 text-white group-hover:text-[#F46653] transition-colors duration-200 shrink-0" />
//                 <a 
//                   href="mailto:support@eurofoxsms.com" 
//                   className="hover:text-white transition-all duration-300 ease-in-out"
//                 >
//                   info@deetyasoft.com,<br />
//                   support@eurofox.com
//                 </a>
//               </li>
//             </ul>
//           </div>

//         </div>
//       </div>

//       {/* SHINY ANIMATED LINE 2 */}
//       <div className="relative h-px w-full overflow-hidden bg-slate-900">
//         <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#F46653]/30 to-transparent animate-[shimmer_3s_infinite] -translate-x-full"></div>
//       </div>

//       <div className="bg-slate-950 py-6">
//         <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          
//           <div className="text-sm text-slate-500">
//             © {new Date().getFullYear()} Eurofox Bulk SMS Service. All rights reserved.
//           </div>

//           <div className="flex gap-3">
//             {[
//               { icon: Facebook, label: 'Facebook' },
//               { icon: Twitter, label: 'Twitter' },
//               { icon: Linkedin, label: 'LinkedIn' },
//               { icon: Instagram, label: 'Instagram' },
//             ].map((social) => (
//               <motion.a
//                 key={social.label}
//                 whileHover={{ y: -5 }}
//                 whileTap={{ scale: 0.95 }}
//                 href="#"
//                 className="p-2.5 bg-white/5 hover:bg-white/10 rounded-xl transition-all duration-300 group border border-white/5 hover:border-white/10"
//                 aria-label={social.label}
//               >
//                 <social.icon className="w-4 h-4 text-slate-400 group-hover:text-[#F46653] transition-colors" />
//               </motion.a>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* REQUIRED CSS ANIMATION */}
//       <style jsx>{`
//         @keyframes shimmer {
//           100% {
//             transform: translateX(100%);
//           }
//         }
//       `}</style>
//     </footer>
//   );
// };

// export default Footer;





import React from 'react';
import { motion } from "framer-motion";
import {
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Mail,
  Phone,
  MapPin,
  Globe
} from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const productLinks = [
    { name: 'Features', path: '/features' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Bulk SMS', path: '/products/bulk-sms' },
    { name: 'OTP SMS', path: '/products/otp' },
    { name: 'IVR Service', path: '/products/ivr' },
    { name: 'LMS', path: '/products/lms' },
    { name: 'Missed Call', path: '/products/missed-call' },
    { name: 'Whatsapp API', path: '/products/whatsapp' },
  ];

  const legalLinks = [
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Terms & Conditions', path: '/terms-and-conditions' },
    { name: 'Cookie Policy', path: '#' },
  ];

  return (
    <footer className="bg-slate-950 text-slate-300 font-sans border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">

          <div className="lg:col-span-4 space-y-6">
            <div className="flex items-center z-10">
              <a href="/" className="group cursor-pointer no-underline bg-[#F0EFEB] p-3 rounded-xl border border-white/5 hover:bg-slate-50/10 transition-colors">
                <h1 className="text-3xl font-extrabold tracking-widest uppercase flex items-baseline">
                  <span className="font-[Roboto] text-[#0C4550] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)] bg-clip-text text-transparent bg-gradient-to-br from-white to-slate-400 lg:text-[#0C4550] lg:bg-none lg:text-current">
                    <span className="text-[#0C4550] lg:text-[#0C4550] drop-shadow-md">EURO</span>
                  </span>
                  <span className="font-[Roboto] text-[#F46653] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)]">
                    FOX
                  </span>
                  <span className="w-2.5 h-2.5 rounded-full bg-[#F46653] ml-1 animate-pulse shadow-sm"></span>
                </h1>
              </a>
            </div>

            <p className="text-slate-400 leading-relaxed text-sm pr-4">
              Empowering businesses with reliable, high-speed bulk SMS solutions.
              Connect with your audience instantly through our secure, enterprise-grade
              global gateway tailored for maximum delivery rates.
            </p>
          </div>

          <div className="lg:col-span-2">
            <p className="text-white font-semibold text-lg mb-6 relative inline-block">
              Product
              <span className="absolute -bottom-2 left-0 w-8 h-1 bg-[#F46653] rounded-full"></span>
            </p>
            <ul className="space-y-3 text-sm">
              {productLinks.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className="hover:text-blue-400 transition-all duration-300 ease-in-out block hover:translate-x-2"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="text-white font-semibold text-lg mb-6 relative inline-block">
              Legal
              <span className="absolute -bottom-2 left-0 w-8 h-1 bg-[#F46653] rounded-full"></span>
            </p>
            <ul className="space-y-3 text-sm">
              {legalLinks.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className="hover:text-blue-400 transition-all duration-300 ease-in-out block hover:translate-x-2"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-white font-semibold text-lg mb-6 relative inline-block">
              Our Company
              <span className="absolute -bottom-2 left-0 w-8 h-1 bg-[#F46653] rounded-full"></span>
            </p>
            <ul className="space-y-4 text-sm">
              <li>
                <Link
                  to="/about"
                  className="hover:text-blue-400 transition-all duration-300 ease-in-out block font-medium hover:translate-x-2"
                >
                  About Us
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  className="hover:text-blue-400 transition-all duration-300 ease-in-out block font-medium hover:translate-x-2"
                >
                  Contact Us
                </Link>
              </li>

              {/* SHINY ANIMATED LINE 1 */}
              <li className="relative h-px w-full overflow-hidden bg-slate-800 my-2">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#F46653]/40 to-transparent animate-[shimmer_2s_infinite] -translate-x-full"></div>
              </li>

              <li className="flex items-start space-x-3 group cursor-default">
                <MapPin className="w-5 h-5 text-white group-hover:text-[#F46653] transition-colors duration-200 mt-0.5 shrink-0" />
                <span className="group-hover:text-white transition-colors duration-200">
                  Abhay Khand-2, Indirapuram,<br />
                  Ghaziabad, Uttar Pradesh-<br />
                  201014
                </span>
              </li>

              <li className="flex items-center space-x-3 group cursor-pointer">
                <Phone className="w-5 h-5 text-white group-hover:text-[#F46653] transition-colors duration-200 shrink-0" />
                <span className="group-hover:text-white transition-colors duration-200">
                  +91-9717055088
                </span>
              </li>

              <li className="flex items-center space-x-3 group">
                <Mail className="w-5 h-5 text-white group-hover:text-[#F46653] transition-colors duration-200 shrink-0" />
                <a
                  href="mailto:info@deetyasoft.com"
                  className="group-hover:text-white transition-colors duration-200"
                >
                  info@deetyasoft.com
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* SHINY ANIMATED LINE 2 */}
      <div className="relative h-px w-full overflow-hidden bg-slate-900">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#F46653]/30 to-transparent animate-[shimmer_3s_infinite] -translate-x-full"></div>
      </div>

      <div className="bg-slate-950 py-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">

          <div className="text-sm text-slate-500">
            © {new Date().getFullYear()} Eurofox Bulk SMS Service. All rights reserved.
          </div>

          <div className="flex gap-3">
            {[
              { icon: Facebook, label: 'Facebook' },
              { icon: Twitter, label: 'Twitter' },
              { icon: Linkedin, label: 'LinkedIn' },
              { icon: Instagram, label: 'Instagram' },
            ].map((social) => (
              <motion.a
                key={social.label}
                whileHover={{ y: -5 }}
                whileTap={{ scale: 0.95 }}
                href="#"
                className="p-2.5 bg-white/5 hover:bg-white/10 rounded-xl transition-all duration-300 group border border-white/5 hover:border-white/10"
                aria-label={social.label}
              >
                <social.icon className="w-4 h-4 text-slate-400 group-hover:text-[#F46653] transition-colors" />
              </motion.a>
            ))}
          </div>
        </div>
      </div>

      {/* REQUIRED CSS ANIMATION */}
      <style jsx>{`
        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;